import styles from 'css/src/components/common/HelpDropdown.module.scss';

import React, { useMemo } from 'react';

import { Dropdown, DROPDOWN_DIVIDER } from './ui/Dropdown';

import { SecondaryIconButton } from 'js/src/components/common/ui/Button';
import type { DropdownItemProp } from 'js/src/components/common/ui/Dropdown';
import { MODAL_IDS, showModal } from 'js/src/data/modals';
import { HELP_DROPDOWN_OPTIONS, ImmutableFromJS } from 'js/src/libs/consts';
import { useAppDispatch } from 'js/src/libs/RootState';

type TItemPropList = Immutable.List<DropdownItemProp<never>>;

const ToggleButton: React.FC<{
    onClick: (e: React.MouseEvent) => void;
    disabled: boolean;
    ref?: React.Ref<HTMLDivElement>;
}> = React.memo(function ToggleButton({ onClick, disabled, ref }) {
    return (
        <div className={styles['help-dropdown-toggle']} ref={ref}>
            <SecondaryIconButton disabled={disabled} onClick={onClick} icon="help" />
        </div>
    );
});

export const HelpDropdown = () => {
    const dispatch = useAppDispatch();

    const itemPropsList = useMemo(() => {
        const onShowFeedbackModal = () =>
            dispatch(
                showModal({
                    modal_id: MODAL_IDS.SUBMIT_FEEDBACK,
                }),
            );
        return ImmutableFromJS([
            HELP_DROPDOWN_OPTIONS.learn,
            HELP_DROPDOWN_OPTIONS.feedback(onShowFeedbackModal),
            HELP_DROPDOWN_OPTIONS.support,
            HELP_DROPDOWN_OPTIONS.help,
            {
                id: DROPDOWN_DIVIDER,
            },
            {
                id: 'sales',
                href: 'https://lumen5.com/book-a-demo?utm_campaign=6880892-%5BMARKETING%5D%20Demo%20Request%20Form&utm_source=Website&utm_medium=in-app-dropdown',
                target: '_blank',
                icon: 'phone',
                text: 'Contact sales',
            },
        ]) as TItemPropList;
    }, [dispatch]);

    return (
        <>
            <Dropdown
                className={`nav-item ${styles['help-dropdown']} me-l5-12 d-flex align-items-center`}
                ToggleComponent={ToggleButton}
                itemPropsList={itemPropsList}
                breakOverflow
            />
        </>
    );
};
